<template>
	<div>
	<div v-if="view === 'search'" class="text-left">
		<!-- <h1 class="text-center">Users Component</h1> -->

		<div class="UsersHome">
		<h1 class="left-align">Search Study</h1>
		<v-row no-gutters>
			<v-col>
				<p class="p3 left-align">Enter studyId</p>
			</v-col>
			<v-col></v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<v-text-field
					outlined
          label="ex. study101"
          single-line
          hide-details
          v-model="filterUserNameValue"
					@keyup.enter="searchStudy()"
					ref="firstFocus"
      ></v-text-field>
			</v-col>
			<v-col>
				<v-btn @click="searchStudy()" class="btn-default" text>Search</v-btn>
								<v-btn @click="clearFilters()" class="btn-default" text>Clear</v-btn>

			</v-col>
		</v-row>
		<br>

		<div v-show="headers.length !== 0" class="track-respondents-table-container">
			<v-data-table
				:headers="headers"
				:items="studies"
				item-key="userName"
				class="elevation-1"
				:page.sync="page"
				:items-per-page="itemsPerPage"
				hide-default-footer
				@page-count="pageCount = $event"
			>
				<template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
					<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
				</template>
				<!-- <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
					<v-tooltip  :disabled="h.hover === ''" :key="h.value" bottom color="#333">
						<template v-slot:activator="{ on }">
							<span v-on="on">{{h.text}}</span>
						</template>
						<span>{{h.hover}}</span>
					</v-tooltip>
				</template> -->
				<template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="openDetails(item)"
      >
        mdi-account-details
      </v-icon>
    </template>
			</v-data-table>
			<div class="pagination-container">
				<v-row>
					<v-col :cols="2">
						<v-text-field
							:value="itemsPerPage"
							label="Items per page"
							type="number"
							min="1"
							max="15"
							@input="itemsPerPage = parseInt($event, 10)"
						></v-text-field>
					</v-col>
					<v-col :cols="10">
						<v-pagination
							v-model="page"
							:length="pageCount"
						></v-pagination>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
	</div>

	<div v-else>
		<v-btn left absolute style="marginLeft:10px" @click="view='search'">Go Back To Search</v-btn>
		<studydetails @seeUserDetails="loadUserDetails" v-on:backToSearch="view='search'" :studyInfo="studyInfo.studyUuid"></studydetails>
	</div>

	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';

export default {
	name: 'StudiesPage',
	data: () => ({
		selected: [],
		studies: [],
		page: 1,
		pageCount: 0,
		itemsPerPage: 10,
		filterUserNameValue: '',
		view: '',
		studyInfo: {}
	}),
	mounted () {
		this.view = 'search'
	},
	computed: {
		headers: function () {
			return [
				{ text: 'StudyId', value: 'studyId', hover: '', class: 'data-table-header' },
				{ text: 'Status', value: 'currentStudyStatus', hover: '', class: 'data-table-header' },
				{ text: 'StudyTool', value: 'studyTool', hover: '', class: 'data-table-header' },
				{ text: 'Version', value: 'version', hover: '', class: 'data-table-header' },
				{ text: 'PrimaryEmail', value: 'primaryEmail', hover: '', class: 'data-table-header', sortable: false },
				{ text: 'Study Details', value: 'actions', hover: '', class: 'data-table-header', sortable: false }
			]
		}
	},
	methods: {
		filterUsername (val) {
			if (!this.filterUserNameValue) {
				return true;
			}

			return val.toLowerCase().includes(this.filterUserNameValue.toLowerCase());
		},
		clearFilters () {
			this.filterUserNameValue = '';
			this.studies = [];
		},
		selectAll () {
			this.selected = this.studies;
		},
		deselectAll () {
			this.selected = [];
		},
		async searchStudy () {
			var rawRespondents;
			await	researcherApiService.searchStudy(this.filterUserNameValue)
				.then(function (response) {
					if (response && response.data) {
						rawRespondents = response.data;
					}
				});
			this.studies = rawRespondents;
		},
		openDetails (it) {
			this.studyInfo = it
			this.view = 'd'
		},
		loadUserDetails (userName) {
			console.log(userName);
			this.$emit('seeUserDetails', userName);
		}
	}
}
</script>

<style>

</style>
